import React from "react";
import { Row } from "react-bootstrap";
import {
  SiFirebase,
  SiMongodb,
  SiHtml5,
  SiReact,
  SiDart,
  SiJava,
  SiJavascript,
  SiFlutter,
  SiMysql,
  SiCss3,
} from "react-icons/si";
import IconBox from "./widgets/icon_box";

const Techstack = () => {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <IconBox Icon={SiJava} text="JAVA"></IconBox>
      <IconBox Icon={SiJavascript} text="JavaScript"></IconBox>
      <IconBox Icon={SiReact} text="React"></IconBox>
      <IconBox Icon={SiDart} text="Dart"></IconBox>
      <IconBox Icon={SiFlutter} text="Flutter"></IconBox>

      <IconBox Icon={SiHtml5} text="HTML5"></IconBox>
      <IconBox Icon={SiCss3} text="CSS3"></IconBox>

      <IconBox Icon={SiFirebase} text="Firebase"></IconBox>
      <IconBox Icon={SiMongodb} text="MongoDB"></IconBox>
      <IconBox Icon={SiMysql} text="MySQL"></IconBox>
    </Row>
  );
};

export default Techstack;
